var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.053 12.941C12.9658 12.941 12.8951 13.0117 12.8951 13.0989V22.0461C12.8951 22.1333 12.9658 22.204 13.053 22.204H22.0002C22.0874 22.204 22.1581 22.1333 22.1581 22.0461V13.0989C22.1581 13.0117 22.0874 12.941 22.0002 12.941H13.053ZM11.2109 13.0989C11.2109 12.0816 12.0357 11.2568 13.053 11.2568H22.0002C23.0175 11.2568 23.8423 12.0816 23.8423 13.0989V22.0461C23.8423 23.0634 23.0175 23.8882 22.0002 23.8882H13.053C12.0357 23.8882 11.2109 23.0634 11.2109 22.0461V13.0989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00029 7.88828C7.91308 7.88828 7.84238 7.95898 7.84238 8.04619V16.9933C7.84238 17.0806 7.91308 17.1513 8.00029 17.1513H9.9476V18.8354H8.00029C6.98293 18.8354 6.1582 18.0107 6.1582 16.9933V8.04619C6.1582 7.02883 6.98294 6.2041 8.00029 6.2041H16.9474C17.9648 6.2041 18.7895 7.02883 18.7895 8.04619V9.9935H17.1054V8.04619C17.1054 7.95898 17.0347 7.88828 16.9474 7.88828H8.00029Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e85ea753.svg";
export { ForwardRef as ReactComponent };